import { forwardRef, Image, StackProps, VStack } from '@chakra-ui/react';

import Text from 'components/_core/Text';

interface EmptyViewProps extends StackProps {
  imageSrc: string;
  title: string;
  description?: string;
}

const EmptyView = forwardRef<EmptyViewProps, 'div'>(
  ({ description, imageSrc, title, ...props }, ref) => {
    return (
      <VStack alignItems="center" ref={ref} spacing="space-16" {...props}>
        <Image
          alt=""
          height="90px"
          role="presentation"
          src={imageSrc}
          width="90px"
        />

        <VStack maxWidth={372} spacing="space-8">
          <Text fontWeight="weight-500" size="lg" variant="primary">
            {title}
          </Text>

          {description ? (
            <Text align="center" variant="light">
              {description}
            </Text>
          ) : null}
        </VStack>
      </VStack>
    );
  },
);

export default EmptyView;
